module.exports = __webpack_public_path__ + "media/src/images/logos/mass-media/rusbase-730abf59c06ff8918c60ec94378eb2ae.svg";